export default "__VITE_ASSET__DbBPTl3K__"